module.exports = __webpack_public_path__ + "static/media/delete-24px-red.86f67bc8.svg";